/**
 * Catálogo de cards do Meu Desempenho (IDs estáveis, sync web ↔ mobile).
 * Chave ausente em preferencias_ui.desempenho_cards = visível (default).
 */

export const DESEMPENHO_CARD_GROUPS = [
  {
    id: 'kpis',
    label: 'Resumo',
    cards: [
      { id: 'insights_financeiros', label: 'Insights financeiros' },
      { id: 'saldo_atual', label: 'Saldo atual em contas' },
      { id: 'total_receitas', label: 'Total de receitas' },
      { id: 'total_despesas', label: 'Total de despesas' },
      { id: 'saldo_previsto', label: 'Saldo previsto (fim do mês)' },
    ],
  },
  {
    id: 'graficos',
    label: 'Gráficos',
    cards: [
      { id: 'chart_receitas_despesas', label: 'Receitas vs. Despesas' },
      { id: 'chart_evolucao_patrimonio', label: 'Evolução do patrimônio' },
      { id: 'chart_projecao_gastos', label: 'Projeção de gastos comprometidos' },
      { id: 'chart_despesas_categoria', label: 'Por categoria — aba Despesas' },
      { id: 'chart_receitas_categoria', label: 'Por categoria — aba Receitas' },
      { id: 'chart_gasto_medio', label: 'Gasto médio por categoria' },
      { id: 'chart_gasto_portador', label: 'Gastos por portador' },
    ],
  },
  {
    id: 'faturas',
    label: 'Faturas',
    cards: [{ id: 'proximas_faturas', label: 'Próximas faturas' }],
  },
  {
    id: 'planejamento',
    label: 'Planejamento do mês',
    cards: [
      { id: 'renda_mes', label: 'Renda e sobra do mês' },
      { id: 'distribuicao_503020', label: 'Distribuição 50/30/20' },
      { id: 'metas_progresso', label: 'Metas de poupança' },
      { id: 'meta_faturamento', label: 'Meta de faturamento' },
      { id: 'guardado_ano', label: 'Quanto guardei no ano' },
    ],
  },
  {
    id: 'milhas',
    label: 'Milhas',
    cards: [
      { id: 'milhas_recebiveis', label: 'Radar de recebíveis' },
      { id: 'milhas_resumo', label: 'Resumo de milhas (KPIs)' },
      { id: 'milhas_programas', label: 'Detalhe por programa' },
    ],
  },
];

/** Cards renderizados na versão mobile (sem planejamento completo). */
export const DESEMPENHO_CARD_IDS_MOBILE = new Set([
  'insights_financeiros',
  'saldo_atual',
  'total_receitas',
  'total_despesas',
  'saldo_previsto',
  'metas_progresso',
  'chart_receitas_despesas',
  'chart_evolucao_patrimonio',
  'chart_projecao_gastos',
  'chart_despesas_categoria',
  'chart_receitas_categoria',
  'proximas_faturas',
  'milhas_recebiveis',
  'milhas_resumo',
  'milhas_programas',
]);

/**
 * @param {object|null|undefined} preferenciasUi
 * @param {string} cardId
 * @returns {boolean}
 */
export function isCardVisible(preferenciasUi, cardId) {
  const cards = preferenciasUi?.desempenho_cards;
  if (!cards || typeof cards !== 'object') return true;
  return cards[cardId] !== false;
}

/**
 * @param {object|null|undefined} preferenciasUi
 * @returns {Record<string, boolean>}
 */
export function getDesempenhoCardsMap(preferenciasUi) {
  const cards = preferenciasUi?.desempenho_cards;
  return cards && typeof cards === 'object' ? { ...cards } : {};
}

/**
 * Monta preferencias_ui para PATCH, preservando outras chaves.
 * @param {object|null|undefined} preferenciasUiAtual
 * @param {Record<string, boolean>|null} desempenhoCards — null limpa a chave (restaurar padrão)
 */
export function buildPreferenciasUiPatch(preferenciasUiAtual, desempenhoCards) {
  const base =
    preferenciasUiAtual && typeof preferenciasUiAtual === 'object'
      ? { ...preferenciasUiAtual }
      : {};
  if (desempenhoCards == null) {
    base.desempenho_cards = null;
  } else {
    base.desempenho_cards = desempenhoCards;
  }
  return base;
}
